// DS: DS2.6.1
import React from 'react';
import ToggleButton from '../ToggleButton/ToggleButton';
import s from './ToggleButtonGroup.scss';
var ToggleButtonGroup = function (_a) {
    var buttons = _a.buttons, selectedValue = _a.value, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement("div", { className: s['root'] }, buttons.map(function (_a, index) {
        var value = _a.value, tooltipText = _a.tooltipText, ariaLabel = _a.ariaLabel, icon = _a.icon, biData = _a.biData;
        return (React.createElement(ToggleButton, { key: index, activated: value === selectedValue, tooltipText: tooltipText, "aria-label": ariaLabel, icon: icon, disabled: disabled, biData: biData, onClick: function () {
                if (value !== selectedValue && onChange) {
                    onChange(value);
                }
            } }));
    })));
};
ToggleButtonGroup.displayName = 'ToggleButtonGroup';
export default ToggleButtonGroup;
//# sourceMappingURL=ToggleButtonGroup.js.map